'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reduxSimple = require('redux-simple');

var _projectsActions = require('actions/projectsActions');

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _Markup = require('../../../components/Common/Markup');

var _Common = require('../../../components/Common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectShare.pcss');

var getState = function getState(state) {
  return {
    project: state.projects.project,

    shareLoaded: state.projects.shareLoaded,
    shareLoading: state.projects.shareLoading,
    sharePopupOpened: state.projects.sharePopupOpened,

    shareLink: state.projects.shareLink
  };
};

var ProjectShare = (_dec = (0, _reduxSimple.connect)(getState, { shareProject: _projectsActions.shareProject, shareProjectShowFBPopup: _projectsActions.shareProjectShowFBPopup }), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ProjectShare, _Component);

  function ProjectShare() {
    _classCallCheck(this, ProjectShare);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectShare).apply(this, arguments));
  }

  _createClass(ProjectShare, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inputNode = (0, _reactDom.findDOMNode)(this.refs.linkInput);
      (0, _raf2.default)(function () {
        return inputNode.select();
      });
    }
  }, {
    key: 'getFBShareLink',
    value: function getFBShareLink() {
      var project = this.props.project;


      this.props.shareProject(project);
    }
  }, {
    key: 'showFBPopup',
    value: function showFBPopup() {
      var shareLink = this.props.shareLink;


      this.props.shareProjectShowFBPopup(shareLink);
    }
  }, {
    key: 'getFacebookButton',
    value: function getFacebookButton() {
      var _props = this.props;
      var shareLoaded = _props.shareLoaded;
      var shareLoading = _props.shareLoading;
      var sharePopupOpened = _props.sharePopupOpened;


      if (!shareLoaded || sharePopupOpened) {
        return _react2.default.createElement(
          _Common.Button,
          { loading: shareLoading, onClick: this.getFBShareLink.bind(this), facebook: true, small: true },
          'Facebook'
        );
      }

      return _react2.default.createElement(
        _Common.Button,
        { onClick: this.showFBPopup.bind(this), facebook: true, small: true },
        'Share'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var project = _props2.project;
      var shareLoading = _props2.shareLoading;
      var shareLoaded = _props2.shareLoaded;
      var sharePopupOpened = _props2.sharePopupOpened;

      var projectShareLink = 'https://meta.pro/project/' + project.id;

      return _react2.default.createElement(
        'div',
        { className: styles.projectShare },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          _react2.default.createElement(
            _Markup.HeadingMedium,
            { noMargins: true },
            'Share project'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.link },
          _react2.default.createElement(
            'div',
            { className: styles.label },
            'Link:'
          ),
          _react2.default.createElement('input', { ref: 'linkInput', readOnly: true, className: styles.input, value: projectShareLink })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.social },
          _react2.default.createElement(
            'div',
            { className: styles.label },
            'Social:'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.buttons },
            this.getFacebookButton(),
            shareLoading && _react2.default.createElement(
              'div',
              { className: styles.caption },
              'Generating image...'
            ),
            shareLoaded && !sharePopupOpened && _react2.default.createElement(
              'div',
              { className: styles.caption },
              'Done!'
            )
          )
        )
      );
    }
  }]);

  return ProjectShare;
}(_react.Component), _class2.propTypes = {
  onSubmitted: _react.PropTypes.func.isRequired,
  project: _react.PropTypes.object.isRequired,

  shareLoaded: _react.PropTypes.bool,
  shareLoading: _react.PropTypes.bool,
  sharePopupOpened: _react.PropTypes.bool,

  shareLink: _react.PropTypes.string
}, _temp)) || _class);
exports.default = ProjectShare;


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectShare/ProjectShare.js
// module id = 577
// module chunks = 1